import {
    Button,
    Typography
}                        from "@mui/material";
import {useGobesContext} from "../context/GobesContextProvider";

const DeleteForm = () =>
{
    const {setModalVisible, deleteCallback} = useGobesContext()

    function onClickSubmit()
    {
        deleteCallback.delete()
        setModalVisible(false)
    }

    return (<>

        <Typography id="modal-modal-title" variant="h6" component="h2">
            Weet je zeker dat je dit item wil verwijderen?
        </Typography>
        <Button variant="contained" onClick={onClickSubmit}>Verwijderen</Button>
        <Button variant="contained" onClick={() => setModalVisible(false)}>Annuleren</Button>
    </>)
}
export default DeleteForm